"use client"

import { styled } from "@mui/material";
import { PageLayout } from "../pageLayout";

export const StyledWhatIsRos1Nsclc = styled(PageLayout)(({ theme }) => ({
    margin: '0 auto',
    strong: {color: 'black'}
}))